export default {
    url: '',
    template: '<courses-courses-list sites="vm.sites" classifiers="vm.classifiers" view="\'list\'">',
    resolve: {
        sites (SiteResource) {
            return SiteResource.query({ pageSize: 0 }).$promise;
        },
        classifiers (ClassifierResource) {
            return ClassifierResource.query({ pageSize: 0, expand: 'activeI18n' }).$promise;
        }
    },
    controller (classifiers, sites) {
        this.classifiers = classifiers;
        this.sites = sites;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/list/index.js